/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftFeatureFlags
 * @format
 * 
 */

'use strict';

var DraftFeatureFlags = require('./DraftFeatureFlags-core');

module.exports = DraftFeatureFlags;


//////////////////
// WEBPACK FOOTER
// ./~/draft-js/lib/DraftFeatureFlags.js
// module id = 51
// module chunks = 0 1